import React, {useContext, useEffect, useState} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";

import DropDown2 from "../../Generic/dropDown2";
import {getAvailableWizardVisualizerOptions} from "../../WizardSetup/WizardSetupTopVisualizerSelect";
import {getWizardList} from "../../WizardSetup/wizardActions";
import {getWizardOption, getWizardsOptions} from "./DiscountsPopupDropdownsOptions";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import WizardGroupsFlow from "../../WizardSetup/WizardGroups/WizardGroupsFlow";
import DiscountsPopupContentWizardButton from "./DiscountsPopupContentWizardButton";
import {setWorkSheetWizardSelections} from "../discountsActions";


const DiscountsPopupContentDropdowns = (props) => {

  const {wizardList, fabricatorSubscriptions, intl, wizardListReceived, getWizardList, setWorkSheetWizardSelections,
    workSheetWizardSelectionsActive} = props;

  const [visualizersOpened, setVisualizersOpened] = useState(false);
  const [wizardOpened, setWizardOpened] = useState(false);

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const {forVisualizer, forWizardName, forWizardHashId} = uiPopupContext;

  const visualizerDropDownItems = getAvailableWizardVisualizerOptions(fabricatorSubscriptions, intl, true);
  const wizardDropDownItems = getWizardsOptions(wizardList);
  const activeWizard = wizardList.length && forWizardHashId ? wizardList.find(wizard => wizard.uniqueHashId === forWizardHashId) : null;

  const subscription = forVisualizer || (visualizerDropDownItems[0] ? visualizerDropDownItems[0].value : null);

  const changeVisWizards = async () => {
    if (subscription && !forVisualizer) {
      onDropdownChange("forVisualizer", subscription);
    }
    if (!subscription) {
      return
    }
    const wizList = await getWizardList(subscription);
    if (!forWizardHashId || (wizList.length && !wizList.some(wizItem => wizItem.uniqueHashId === forWizardHashId))) {
      onWizardSelect(null, getWizardOption(wizList[0] || {}))
    }
  }

  useEffect(() => {
    changeVisWizards();
  }, [forVisualizer]);

  useEffect(() => {
    return () => {
      setWorkSheetWizardSelections(false); // clear wizard
    }
  }, [])

  const onDropdownChange = (property, value, closeFunc) => {
    uiPopupDispatch({
      [property]: value
    });
    if (closeFunc) {
      closeFunc(false)
    }
  }

  const onVisualizerSelect = (value) => {
    if (value !== forVisualizer) {
      onDropdownChange("forWizardGroupTitle", "");
      onDropdownChange("forWizardGroupId", "");
      onDropdownChange("forWizardGroupName", "");
      onDropdownChange("saveButtonDisabled", true);
      onDropdownChange("forWizardName", "");
      onDropdownChange("forWizardId", "");
      onDropdownChange("forWizardHashId", "");
    }
    onDropdownChange("forVisualizer", value, setVisualizersOpened);
  }

  const onWizardSelect = (value, item) => {
    if (item.forWizardHashId !== forWizardHashId) {
      onDropdownChange("forWizardGroupTitle", "");
      onDropdownChange("forWizardGroupId", "");
      onDropdownChange("forWizardGroupName", "");
      onDropdownChange("saveButtonDisabled", true);
    }
    onDropdownChange("forWizardName", item.forWizardName || null, setWizardOpened);
    onDropdownChange("forWizardId", item.forWizardId || null);
    onDropdownChange("forWizardHashId", item.forWizardHashId || null);
  }

  if (activeWizard && workSheetWizardSelectionsActive) {
    return <WizardGroupsFlow wizardActiveItem={activeWizard}/>
  }

  return (
    <div className="fs-toggle-popup__table">
      <div className="fs-toggle-popup__table-row margin-b8 flex flex--center height-34">
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name text-left">
          Select Visualizer:
        </div>
        <div className="flex-item--50">
          <div className={"fc-inst__select relative" + (visualizersOpened ? " select2--active" : "")}>
            <div className="select2-value text-capitalize" onClick={() => setVisualizersOpened(true)}>
              {subscription}
            </div>
            {visualizersOpened ? (
              <DropDown2 selected={forVisualizer}
                         items={visualizerDropDownItems}
                         onClickOutside={() => setVisualizersOpened(false)}
                         onSelect={onVisualizerSelect}
                         useVirtualizedList={false}
                         filter={false}/>
            ) : null}
          </div>
        </div>
      </div>
      <div className="fs-toggle-popup__table-row margin-b8 flex flex--center height-34">
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name text-left">
          Select Wizard:
        </div>
        <div className="flex-item--50">
          {!wizardListReceived ? <div className="ui-loader ui-loader--small"/> : (
            <div className={"fc-inst__select relative" + (wizardOpened ? " select2--active" : "")}>
              <div className="select2-value" onClick={() => setWizardOpened(true)}>
                {forWizardName || null}
              </div>
              {wizardOpened ? (
                <DropDown2 selected={null}
                           items={wizardDropDownItems}
                           onClickOutside={() => setWizardOpened(false)}
                           onSelect={onWizardSelect}
                           useVirtualizedList={false}
                           filter={false}/>
              ) : null}
            </div>
          )}
        </div>
      </div>
      <div className="fs-toggle-popup__table-row flex flex--center height-34">
        <div className="fs-toggle-popup__table-col fs-toggle-popup__table-col--name text-left">
          Select Group:
        </div>
        <div className="flex-item--50">
          {!wizardListReceived ? <div className="ui-loader ui-loader--small"/> : (
            // <div className={"fc-inst__select relative" + (groupOpened ? " select2--active" : "")}>
            //   <div className="select2-value" onClick={() => setGroupOpened(true)}>
            //     {forWizardGroupTitle || forWizardGroupName || "Select group..."}
            //   </div>
            //   {groupOpened ? (
            //     <DropDown2 selected={null}
            //                items={wizardGroupsOptions}
            //                onClickOutside={() => setGroupOpened(false)}
            //                onSelect={onGroupSelect}
            //                useVirtualizedList={true}
            //                filter={true}/>
            //   ) : null}
            // </div>
            <DiscountsPopupContentWizardButton/>
          )}
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {workSheetsActiveIndex, discountSections, workSheetWizardSelectionsActive} = store.discountsState;
  const {wizardList, wizardListReceived} = store.wizardState;
  const {fabricatorSubscriptions} = store.newScope;

  return {
    discountSections,
    workSheetsActiveIndex,
    wizardList,
    fabricatorSubscriptions,
    wizardListReceived,
    workSheetWizardSelectionsActive,
  };
};

const mapDispatchToProps = {
  getWizardList,
  setWorkSheetWizardSelections,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DiscountsPopupContentDropdowns)
)
